import { kiosk_IMAGES } from "@/assets/IMAGES";

const service_offer = [
  {
    id: 1,
    img: kiosk_IMAGES.attest_doc,
    service_name: "Attest Documnet",
    ticket_time: "09:48",
  },
  {
    id: 2,
    img: kiosk_IMAGES.verify_doc,
    service_name: "Document Verification",
    ticket_time: "09:48",
  },
  {
    id: 3,
    img: kiosk_IMAGES.inquiry,
    service_name: "Addmimission Inquiry",
    ticket_time: "09:48",
  },
  {
    id: 4,
    img: kiosk_IMAGES.exam,
    service_name: "Exam Registration",
    ticket_time: "09:48",
  },
  {
    id: 5,
    img: kiosk_IMAGES.scholarship,
    service_name: "Scholarship Assistance",
    ticket_time: "09:48",
  },
  {
    id: 6,
    img: kiosk_IMAGES.course,
    service_name: "Course Installment",
    ticket_time: "09:48",
  },
];
const service = [
  { id: 1, img: "", service_name: "Relegious Affair" },
  { id: 2, img: "", service_name: "Education" },
  { id: 3, img: "", service_name: "Welfare" },
  { id: 4, img: "", service_name: "Budgeting & Accounts" },
  { id: 5, img: "", service_name: "Human Resources" },
  { id: 6, img: "", service_name: "Internal Affairs" },
  { id: 7, img: "", service_name: "Internal Affairs" },
  { id: 8, img: "", service_name: "Internal Affairs" },
  { id: 9, img: "", service_name: "Internal Affairs" },
  { id: 10, img: "", service_name: "Internal Affairs" },
  { id: 11, img: "", service_name: "Internal Affairs" },
  { id: 12, img: "", service_name: "Internal Affairs" },
  { id: 13, img: "", service_name: "Internal Affairs" },
];

interface Days {
  id: number;
  title: string;
  day: string;
}

const serviceDays: Days[] = [
  
  {
    id: 1,
    day: "Monday",
    title: "M",
  },
  {
    id: 2,
    day: "Tuesday",
    title: "T",
  },
  {
    id: 3,
    day: "Wednesday",
    title: "W",
  },
  {
    id: 4,
    day: "Thursday",
    title: "T",
  },
  {
    id: 5,
    day: "Friday",
    title: "F",
  },
  {
    id: 6,
    day: "Saturday",
    title: "S",
  },
  {
    id: 7,
    day: "Sunday",
    title: "S",
  },
];

export { service, service_offer, serviceDays };
